import { ArrowLeft } from 'lucide-react';
import type { WorkOrderDetailViewModel } from '../types/workOrderDetail.types';

export function DetailSummaryHeader({ data }: { data: WorkOrderDetailViewModel }) {
  return (
    <div className="min-w-0 space-y-2">
      <div className="flex flex-wrap items-center gap-2">
        <span className="p-3 sm:text-sm text-xs font-semibold text-blue-600">{data.code}</span>
        <span className="rounded-md bg-blue-50 px-2 py-1 sm:text-sm text-xs text-blue-600">{data.workTypeLabel}</span>
        <span className="rounded-md bg-emerald-50 px-2 py-1 sm:text-sm text-xs text-emerald-600">{data.statusLabel}</span>
      </div>
      <h1 className="text-2xl leading-tight text-slate-950">{data.title}</h1>
      <p className="line-clamp-2 sm:text-sm text-xs text-slate-500">{data.projectName} - {data.zoneName}</p>
    </div>
  );
}
